import React from 'react';
import { Shield, CheckCircle, Clock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const Guarantee = ({ onEnroll }) => {
  return (
    <section className="py-16 bg-gradient-to-br from-emerald-600 to-teal-700 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjB2NjBIMHoiLz48cGF0aCBkPSJNMzAgMzBtLTEgMGExIDEgMCAxIDAgMiAwYTEgMSAwIDEgMCAtMiAwIiBmaWxsPSJ3aGl0ZSIvPjwvZz48L3N2Zz4=')]" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8">
            {/* Badge */}
            <div className="flex-shrink-0">
              <div className="w-32 h-32 rounded-full bg-white/10 backdrop-blur-sm border-4 border-white/30 flex items-center justify-center">
                <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center">
                  <Shield className="w-12 h-12 text-emerald-600" />
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="text-center md:text-left flex-1">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                100% Free. No Strings Attached.
              </h2>
              <p className="text-emerald-100 mb-6">
                We believe everyone deserves access to quality safety training. That&apos;s why this comprehensive 
                OSHA course is completely free - no credit card required, no hidden fees, no upsells.
              </p>
              
              <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-6">
                {[
                  'Full course access',
                  'All 8 modules included',
                  'Certificate of completion',
                  'Lifetime access'
                ].map((item, i) => (
                  <span key={i} className="flex items-center gap-2 text-white text-sm">
                    <CheckCircle className="w-4 h-4 text-emerald-300" />
                    {item}
                  </span>
                ))}
              </div>

              <Button
                onClick={onEnroll}
                className="bg-white hover:bg-slate-100 text-emerald-700 px-8 py-6 text-lg font-semibold rounded-xl shadow-lg transition-all hover:-translate-y-0.5"
              >
                Start Learning Now - It&apos;s Free
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
